import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

export default function Conditions() {
  return (
    <div className="landing" style={{ minHeight: '100vh', padding: '2rem' }}>
      <Helmet>
        <title>Mentions légales — CloudyPocket</title>
      </Helmet>

      <div style={{ maxWidth: '800px', margin: '4rem auto' }}>
        <Link to="/" style={{ color: 'var(--dark-text-low)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem', fontSize: '0.9rem' }}>
          <FontAwesomeIcon icon={faArrowLeft} /> Retour à l'accueil
        </Link>

        <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '2rem' }}>Conditions générales</h1>

        <article style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--dark-text-high)' }}>Politique de confidentialité</h2>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Collecte des Informations Personnelles</h3>
          <p style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', marginBottom: '0.75rem' }}>
            Nous collectons les informations personnelles suivantes lors de l'inscription et de l'utilisation de notre application :
          </p>
          <ul style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
            <li>Nom et prénom</li>
            <li>Adresse e-mail</li>
            <li>Mot de passe (crypté en base de données)</li>
          </ul>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Utilisation des Données</h3>
          <p style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', marginBottom: '0.75rem' }}>
            Les utilisateurs ont un accès total à leurs données et peuvent les modifier à tout moment :
          </p>
          <ul style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
            <li><strong>Gestion du compte utilisateur</strong> : Les utilisateurs peuvent modifier leurs informations personnelles.</li>
            <li><strong>Suppression du compte</strong> : La suppression du compte utilisateur entraîne la suppression de toutes les données associées.</li>
          </ul>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Données Financières</h3>
          <p style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', marginBottom: '0.75rem' }}>
            Pendant l'utilisation de l'application, les utilisateurs peuvent :
          </p>
          <ul style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
            <li>Uploader des tickets de caisse</li>
            <li>Créer des comptes bancaires avec : nom du compte, devise, solde initial, informations bancaires (facultatif)</li>
            <li>Créer des transactions bancaires (débits, crédits, transferts et échéanciers)</li>
          </ul>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Sécurité</h3>
          <p style={{ color: 'var(--dark-text-low)', lineHeight: '1.7' }}>
            Nous prenons des mesures pour protéger vos données personnelles, y compris le hachage des mots de passe et le chiffrement AES-256-CBC de toutes les données bancaires et financières.
          </p>
        </article>

        <article>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--dark-text-high)' }}>Mentions légales</h2>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Informations</h3>
          <div style={{ color: 'var(--dark-text-low)', lineHeight: '1.7', marginBottom: '1rem' }}>
            <p><strong>Responsable</strong> : Yann Ghistelinck</p>
            <p><strong>Adresse</strong> : 17 rue du Docteur Repin</p>
            <p><strong>Ville</strong> : 72240, Conlie</p>
            <p><strong>Email</strong> : <Link to="/contact" style={{ color: 'var(--dark-solid)' }}>contact@cloudy-pocket.fr</Link></p>
          </div>

          <h3 style={{ fontSize: '1.1rem', margin: '1.5rem 0 0.75rem', color: 'var(--dark-text-high)' }}>Hébergeur</h3>
          <div style={{ color: 'var(--dark-text-low)', lineHeight: '1.7' }}>
            <p><strong>Nom</strong> : O2switch</p>
            <p><strong>Adresse</strong> : Chemin des Pardiaux</p>
            <p><strong>Ville</strong> : 63000, Clermont Ferrand</p>
            <p><strong>Email</strong> : support@o2switch.fr</p>
          </div>
        </article>
      </div>
    </div>
  )
}
